<meta http-equiv='cache-control' content='no-cache'>
<meta http-equiv='expires' content='0'>
<meta http-equiv='pragma' content='no-cache'>
<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title text-primary pl-2 pl-md-1 letter-spacing">
      ONLINE CONSULTATION
    </h5>
  </div>
  <form class="form-group" [formGroup]="prescriptionForm">
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="font-size-15 text-primary font-weight-600 letter-spacing">
              PATIENT DETAILS
            </h5>
            <div class="row pt-2">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-4">
                  <label class="font-color label-text">Name</label>
                </div>
                <div class="col-md-8">
                  <p class="text-capitalize text-color">
                    {{ patient?.first_name }} {{ patient?.last_name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-4">
                  <label class="font-color label-text">Date of birth</label>
                </div>
                <div class="col-md-8">
                  <p class="text-capitalize text-color">
                    {{ patient?.dob | date: dateFormat }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-4">
                  <label class="font-color label-text">Gender</label>
                </div>
                <div class="col-md-8">
                  <p class="text-capitalize text-color">
                    {{ patient?.gender }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-4">
                  <label class="font-color label-text">Contact</label>
                </div>
                <div class="col-md-8">
                  <p class="text-capitalize text-color">
                    {{ patient?.contact_no }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-4">
                  <label class="font-color label-text">Email</label>
                </div>
                <div class="col-md-8">
                  <p class="text-color text-break">
                    {{ patient?.email_id }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-4">
                  <label class="font-color label-text">Drug Allergy</label>
                </div>
                <div class="col-md-8">
                  <p class="text-color">
                    {{ appointment?.drug_allergy ? "Yes" : "No" }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-4">
                  <label class="font-color label-text">Concern</label>
                </div>
                <div class="col-md-8">
                  <p class="text-color">
                    {{ appointment?.remarks }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-3" *ngIf="appointments?.length > 0">
          <div class="card-body">
            <h5 class="font-size-15 text-primary font-weight-600 letter-spacing">
              PAST APPOINTMENTS
            </h5>
            <div class="row" *ngIf="appointments?.length > 0">
              <div class="col-md-12 detail-tbl">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Type</th>
                        <th scope="col">Date</th>
                        <th scope="col">Time</th>
                        <th scope="col">Patient Name</th>
                        <th scope="col">Consulting Doctor</th>
                        <th scope="col">View Appointment</th>
                      </tr>
                    </thead>
                    <tr *ngFor="let apt of appointments">
                      <td class="text-capitalize">{{ apt?.apttype }}</td>
                      <td>{{ apt?.apdate | date: dateFormat }}</td>
                      <td>{{ apt?.aptime }}</td>
                      <td class="text-capitalize">{{ apt?.pat_name }}</td>
                      <td class="text-capitalize">{{ apt?.phy_name }}</td>
                      <td *ngIf="apt?.consultation_link">
                        <a class="cursor" href="{{ apt?.consultation_link }}" target="_blank">View</a>
                      </td>
                      <td *ngIf="!apt?.consultation_link"></td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  New Changes-->

        <div class="card mb-3" *ngIf="appointment?.documents && appointment?.documents?.length > 0">
          <div class="card-body">
            <h5 class="font-size-15 text-primary font-weight-600 letter-spacing">
              PATIENT DOCUMENTS
            </h5>
            <div class="row">
              <div class="col-md-12 detail-tbl">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Description</th>
                        <th scope="col">Name</th>
                        <th scope="col">Preview</th>
                        <th scope="col">Download</th>
                      </tr>
                    </thead>
                    <tr *ngFor="let doc of appointment?.documents">
                      <td class="text-capitalize">{{ doc?.description }}</td>
                      <td>{{ doc?.name }}</td>
                      <td>
                        <a class="cursor" (click)="previewDocument(doc)">Preview</a>
                      </td>
                      <td>
                        <a class="cursor" (click)="downloadDocument(doc)">Download</a>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  New Changes-->

        <div class="card mb-3">
          <div class="card-body">
            <h5 class="font-size-15 text-primary font-weight-600 letter-spacing">
              CONSULTATION SUMMARY<span class="text-danger">*</span>
            </h5>
            <div class="row pt-1">
              <div class="col-md-12">
                <fieldset [disabled]="!isEditable ? 'disabled' : null">
                  <div class="textarea-wrapper">
                    <textarea class="form-control h-311px" placeholder="Consultation Summary here..." maxlength="2500"
                      formControlName="summary"></textarea>
                    <span class="remaning float-right">
                      {{ getControl('summary')?.value?.length + "/ 2500"}}</span>
                  </div>
                  <!-- <div align="end">
                    {{getControl('summary')?.value?.length || 0}}
                  </div> -->
                  <div *ngIf="
                      prescriptionForm.get('summary').hasError('required') &&
                      isEditable
                    " class="invalid-feedback">
                    This is required
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12" *ngIf="isEditable">
        <div class="card m-b-30">
          <div class="card-body">
            <div formArrayName="prescriptionItems">
              <!-- <h5 class="header-title text-primary">PRESCRIPTION</h5> -->
              <h5 class="mt-2 ml-4">Prescription
                <span *ngIf="panel_expa" class="pull-right mr-4 "
                  style="cursor: pointer;font-size: small;text-shadow: 5px 5px 10px rgb(194, 98, 85);">
                  <div (click)="panel_expa = !panel_expa;this.tmpl_expa = false;"> CLOSE PRESCRIPTION TEMPLATES </div>
                </span>
                <span *ngIf="!panel_expa" class="pull-right mr-4 "
                  style="cursor: pointer;font-size: small;text-shadow: 5px 5px 10px rgb(104, 90, 180);">
                  <div (click)="panel_expa = !panel_expa;this.tmpl_expa = false;"> USE PRESCRIPTION TEMPLATES </div>
                </span>
              </h5>
              <br /><br />
              <div class="col-lg-12" *ngIf="panel_expa">
                <form class="form-group" [formGroup]="tmpl_search_form">
                  <div class="card m-b-30">
                    <div class="card-body">
                      <div>
                        <div class="row">
                          <div class="text-primary form-group col-md-2"></div>
                          <div class="text-primary form-group col-md-2 pt-3" style="text-align: right;">Enter Template
                            Name
                          </div>
                          <div class="form-group col-md-4">
                            <input class="form-control" formControlName="tmpl_name_org" type="text">
                          </div>
                          <div class="text-primary form-group col-md-2 pt-2 "><button
                              class="btn btn-primary pl-5 pr-5 mr-2 mb-2 mb-md-2 btn-rounded" type="submit"
                              (click)="searchtmpl()">
                              SEARCH
                            </button></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div *ngIf="tmpl_expa">
                <form class="form-group" [formGroup]="prescriptiontmplForm">
                  <div class="container-fluid" *ngIf="cate?.length">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="card m-b-30">
                          <div class="card-body table-responsive">
                            <div class="col-md-12 detail-tbl">
                              <div *ngFor="let q of unique; let j = index;">
                                <div class="card">
                                  <div class="card-body">
                                    <h5 class="text-primary">{{ q.tmpl_name}}</h5> <br /><br />
                                    <!-- HEADING -->
                                    <div class="row col-12">
                                      <div class="col md-2 font-size-16 text-primary align-middle"> Medicine Name</div>
                                      <div class="col md-1 font-size-16 text-primary align-middle">Strength</div>
                                      <div class="col md-1 font-size-16 text-primary align-middle pl-2"> Intake type
                                      </div>
                                      <div class="col md-1 font-size-16 text-primary align-middle"> Intake Freq</div>
                                      <div class="col md-1 font-size-16 text-primary align-middle"> Intake</div>
                                      <div class="col md-3 font-size-16 text-primary align-middle"> Starts On</div>
                                      <div class="col md-3 font-size-16 text-primary align-middle"> Ends On</div>
                                    </div>
                                    <br /><br />
                                    <section class="">
                                      <form [formGroup]="forms['appetiteHabits']">
                                        <div class="col-12 col-sm-12">
                                          <!-- <div class="form-group" formArrayName="medicine_template"
                                            *ngFor="let item of forms['appetiteHabits'].get('medicine_template')['controls']; let i = index;">
                                            <div class="row" [formGroupName]="i"
                                              *ngIf="q?.tmpl_id  && cate[i]?.tmpl_id">
                                              <div class="row">
                                                <div *ngIf="q.tmpl_id==cate[i].tmpl_id"
                                                  class="col md-2 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicineNameLabels(i)}}</div>
                                                <div *ngIf="q.tmpl_id==cate[i].tmpl_id"
                                                  class="col md-1 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicinestrengthLabels(i)}}</div>
                                                <div *ngIf="q.tmpl_id==cate[i].tmpl_id"
                                                  class="col md-1 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicineintakeLabels(i)}}</div>
                                                <div *ngIf="q.tmpl_id==cate[i].tmpl_id"
                                                  class="col md-1 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicineintakefreqLabels(i)}}</div>
                                                <div *ngIf="q.tmpl_id==cate[i].tmpl_id"
                                                  class="col md-1 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicineintakefreq_typeLabels(i)}}</div>
                                                <div class="col md-3 " *ngIf="q.tmpl_id==cate[i].tmpl_id">
                                                  <div class="form-group w-30">
                                                    <div class="input-group w-100">
                                                      <input required class="form-control"
                                                        placeholder="Medication Start Date(dd/mm/yyyy)"
                                                        formControlName="sdate" ngbDatepicker #d1="ngbDatepicker"
                                                        data-date-inline-picker="false" [minDate]="currentDate">
                                                      <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary calendar rounded-0"
                                                          (click)="d1.toggle()" type="button" style="line-height: 2.5;">
                                                          <span class="fa fa-calendar"></span>
                                                        </button>
                                                      </div>

                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col md-3" *ngIf="q.tmpl_id==cate[i].tmpl_id">
                                                  <div class="form-group w-30">
                                                    <div class="input-group w-100">
                                                      <input required class="form-control"
                                                        placeholder="Medication End Date(dd/mm/yyyy)"
                                                        formControlName="edate" ngbDatepicker #d="ngbDatepicker"
                                                        data-date-inline-picker="false" [minDate]="currentDate" />
                                                      <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary calendar rounded-0"
                                                          (click)="d.toggle()" type="button" style="line-height: 2.5;">
                                                          <span class="fa fa-calendar"></span>
                                                        </button>
                                                      </div>

                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> -->


                                          <div class="form-group" formArrayName="medicine_template"
                                            *ngFor="let item of forms['appetiteHabits'].get('medicine_template')['controls']; let i = index;">

                                            <div [formGroupName]="i"
                                              *ngIf="q?.tmpl_id  && cate[i]?.tmpl_id ; else noRecord">
                                              <div class="row" *ngIf="q.tmpl_id==cate[i].tmpl_id ; else noRecord">
                                                <div class="col md-2 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicineNameLabels(i)}}</div>
                                                <div class="col md-1 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicinestrengthLabels(i)}}</div>
                                                <div class="col md-1 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicineintakeLabels(i)}}</div>
                                                <div class="col md-1 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicineintakefreqLabels(i)}}</div>
                                                <div class="col md-1 pt-3 font-size-15 text-dark align-middle">
                                                  {{getMedicineintakefreq_typeLabels(i)}}</div>
                                                <div class="col md-3 ">
                                                  <div class="form-group w-30">
                                                    <div class="input-group w-100">
                                                      <input required class="form-control"
                                                        placeholder="Medication Start Date(dd/mm/yyyy)"
                                                        formControlName="sdate" ngbDatepicker #d1="ngbDatepicker"
                                                        data-date-inline-picker="false" [minDate]="currentDate">
                                                      <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary calendar rounded-0"
                                                          (click)="d1.toggle()" type="button" style="line-height: 2.5;">
                                                          <span class="fa fa-calendar"></span>
                                                        </button>
                                                      </div>

                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col md-3">
                                                  <div class="form-group w-30">
                                                    <div class="input-group w-100">
                                                      <input required class="form-control"
                                                        placeholder="Medication End Date(dd/mm/yyyy)"
                                                        formControlName="edate" ngbDatepicker #d="ngbDatepicker"
                                                        data-date-inline-picker="false" [minDate]="currentDate" />
                                                      <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary calendar rounded-0"
                                                          (click)="d.toggle()" type="button" style="line-height: 2.5;">
                                                          <span class="fa fa-calendar"></span>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </form>
                                    </section>
                                    <button type="button" class="btn btn-primary rondBrtn pull-right mr-4" name="submit"
                                      (click)="submitPrescriptionTemplate(q.tmpl_id)">USE THIS TEMPLATE</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <ng-template #noRecord>

              </ng-template>
              <div class="row" *ngFor="
                  let x of prescriptionForm.get('prescriptionItems')[
                    'controls'
                  ];
                  let i = index;
                  trackBy: track
                " [formGroupName]="i">
                <div class="col-lg-12">
                  <div class="row pt-2">
                    <div class="col-md-3">
                      <input type="text" class="form-control" placeholder="Medicine name" formControlName="mname" />
                      <div *ngIf="
                          prescription.at(i).get('mname') &&
                          prescription.at(i).get('mname').hasError('required')
                        " class="invalid-feedback">
                        This is required
                      </div>
                    </div>
                    <div class="col-md-2">
                      <input type="text" class="form-control" placeholder="Strength (mg/tbsp/ml)"
                        formControlName="strength" />
                      <!-- <div *ngIf="
                          prescription.at(i).get('strength') &&
                          prescription
                            .at(i)
                            .get('strength')
                            .hasError('required')
                        " class="invalid-feedback">
                        This is required
                      </div> -->
                    </div>
                    <div class="form-group col-md-2">
                      <select formControlName="intakefreq_type" name="intakefreq_type" class="form-control"
                        (change)="freqTypeSelected($event, i)">
                        <option *ngFor="let x of intakeFreqTypesList" [value]="x.value">
                          {{ x.value }}
                        </option>
                      </select>
                      <div *ngIf="
                          prescription.at(i).get('intakefreq_type') &&
                          prescription
                            .at(i)
                            .get('intakefreq_type')
                            .hasError('required')
                        " class="invalid-feedback">
                        This is required
                      </div>
                    </div>
                    <div class="form-group col-md-3">
                      <select formControlName="intakefreq" name="intakefreq" class="form-control">
                        <option value="null" disabled selected>
                          Select Frequency
                        </option>
                        <option *ngFor="let x of intakefreqList[i]" [value]="x">
                          {{ x }}
                        </option>
                      </select>
                      <div *ngIf="
                          prescription.at(i).get('intakefreq') &&
                          prescription
                            .at(i)
                            .get('intakefreq')
                            .hasError('required')
                        " class="invalid-feedback">
                        This is required
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <select formControlName="intake" name="intake" class="form-control">
                        <option value="null" disabled selected>Select</option>
                        <option *ngFor="let x of intakeList" [value]="x">
                          {{ x }}
                        </option>
                      </select>
                      <div *ngIf="
                          prescription.at(i).get('intake') &&
                          prescription.at(i).get('intake').hasError('required')
                        " class="invalid-feedback">
                        This is required
                      </div>
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col-md-3">
                      <div class="d-flex">
                        <input class="form-control" placeholder="Medication Start Date(dd/mm/yyyy)" name="sDate"
                          ngbDatepicker #sdate="ngbDatepicker" data-date-inline-picker="true" id="sDate"
                          formControlName="sdate" [minDate]="currentDate" />
                        <div>
                          <button class="btn btn-outline-secondary button-height calendar rounded-0"
                            (click)="sdate.toggle()" type="button" id="sDateButton">
                            <span class="fa fa-calendar"></span>
                          </button>
                        </div>
                      </div>
                      <div *ngIf="
                          prescription.at(i).get('sdate') &&
                          prescription.at(i).get('sdate').hasError('required')
                        " class="invalid-feedback">
                        Start Date is required
                      </div>
                      <div *ngIf="
                          !prescription
                            .at(i)
                            .get('sdate')
                            .hasError('required') &&
                          prescription.at(i).get('sdate').hasError('ngbDate')
                        " class="invalid-feedback">
                        Start Date is invalid
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="d-flex">
                        <input class="form-control" placeholder="Medication End Date (dd/mm/yyyy)" name="eDate"
                          ngbDatepicker #edate="ngbDatepicker" data-date-inline-picker="false" id="eDate"
                          formControlName="edate" [minDate]="
                            prescriptionForm.value.prescriptionItems[i].sdate ||
                            currentDate
                          " />
                        <div>
                          <button class="btn btn-outline-secondary button-height calendar rounded-0"
                            (click)="edate.toggle()" type="button" id="eDateButton">
                            <span class="fa fa-calendar"></span>
                          </button>
                        </div>
                      </div>
                      <div *ngIf="
                          prescription.at(i).get('edate').hasError('required')
                        " class="invalid-feedback">
                        End Date is required
                      </div>
                      <div *ngIf="
                          !prescription
                            .at(i)
                            .get('edate')
                            .hasError('required') &&
                          prescription.at(i).get('edate').hasError('ngbDate')
                        " class="invalid-feedback">
                        End Date is invalid
                      </div>
                    </div>
                    <div class="col-md-5">
                      <textarea class="form-control textbox-height" placeholder="Medicine Instruction" maxlength="300"
                        formControlName="remarks"></textarea>
                    </div>
                    <div class="col-md-1 align-self-center">
                      <div class="tabledit-toolbar btn-toolbar float-none float-md-right">
                        <button *ngIf="i > 0" type="button" class="btn btn-outline-danger mr-2 removeitem"
                          (click)="removingCurrentPrescription(i)">
                          <i class="fa fa-close"></i>
                        </button>
                        <button type="button" class="tabledit-edit-button btn btn-lg btn-success edit"
                          title="Add More Prescription" (click)="addpPrescription()">
                          <span class="ti-plus"></span>
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="bottomForm">
              <div class="row">


                <div class="col-sm-12">
                  <h6 class="heading_color bottomTitle">

                    Patient's Prescription
                    <!-- <span>
                      <a href="javascript:void(0);" (click)="printPage($event)" class="fa fa-file-pdf-o"
                        id="CurrentPrescription"></a>
                    </span> -->
                  </h6>

                  <div *ngIf="currentPrescriptionList?.length;else no_data_templ">
                    <div class="card-body-1 table-responsive">
                      <br>
                      <div class="">
                        <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                          <div class="row">
                            <div class="col-sm-12">
                              <table id="datatable2" class="table dataTable no-footer" role="grid"
                                aria-describedby="datatable2_info">
                                <thead>
                                  <tr role="row">
                                    <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1"
                                      colspan="1" aria-sort="ascending"
                                      aria-label="Name: activate to sort column descending" style="width: 12.3%;">
                                      Medicine</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%;">
                                      Strength</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">
                                      Frequency</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">
                                      Med intake</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">Valid from
                                    </th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">Valid till
                                    </th>
                                    <!-- <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">Prescribed on
                                    </th> -->
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">Prescribed by
                                    </th>
                                    <th *ngIf="ispastapt==false" class="sorting" tabindex="0" aria-controls="datatable2"
                                      rowspan="1" colspan="1" style="width: 12.3%">Delete
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>

                                  <tr role="row" class="odd" *ngFor="let record of currentPrescriptionList">
                                    <td>{{record.mname}}</td>
                                    <td>{{record.strength}}</td>
                                    <td>{{record.intakefreq}}</td>
                                    <td>{{record.intake}}</td>
                                    <td>{{record.sdate| date:'dd-MM-yyyy'}}</td>
                                    <td>{{record.edate| date:'dd-MM-yyyy'}}</td>
                                    <!-- <td>{{record.pdate| date:'dd-MM-yyyy'}}</td> -->
                                    <td>Dr. {{record.first_name}} {{record.last_name}}</td>
                                    <td>
                                      <a href="javascript:void(0);" class="fa fa-close"
                                        (click)="deletePrescription(record)" style="font-size:18px;color:red;"></a>
                                    </td>

                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <ng-template #no_data_templ>
                    <h5 class="mt-3 text-center mt-2"> NO RECORDS FOUND</h5>
                  </ng-template>
                </div>


                <div class="col-sm-12">
                  <h6 class="heading_color bottomTitle">

                    PAST MEDICATIONS
                    <!-- <span>
                      <a href="javascript:void(0);" (click)="printPage($event)" class="fa fa-file-pdf-o"
                        id="CurrentPrescription"></a>
                    </span> -->
                  </h6>

                  <div *ngIf="previousPrescriptionList?.length;else no_data_templ">
                    <div class="card-body-1 table-responsive">
                      <br>
                      <div class="">
                        <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                          <div class="row">
                            <div class="col-sm-12">
                              <table id="datatable2" class="table dataTable no-footer" role="grid"
                                aria-describedby="datatable2_info">
                                <thead>
                                  <tr role="row">
                                    <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1"
                                      colspan="1" aria-sort="ascending"
                                      aria-label="Name: activate to sort column descending" style="width: 12.3%;">
                                      Medicine</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%;">
                                      Strength</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">
                                      Frequency</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">
                                      Med intake</th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">Valid from
                                    </th>
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">Valid till
                                    </th>
                                    <!-- <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">Prescribed on
                                    </th> -->
                                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                      style="width: 12.3%">Prescribed by
                                    </th>
                                    <th *ngIf="ispastapt==false" class="sorting" tabindex="0" aria-controls="datatable2"
                                      rowspan="1" colspan="1" style="width: 12.3%">Delete
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>

                                  <tr role="row" class="odd" *ngFor="let record of previousPrescriptionList">
                                    <td>{{record.mname}}</td>
                                    <td>{{record.strength}}</td>
                                    <td>{{record.intakefreq}}</td>
                                    <td>{{record.intake}}</td>
                                    <td>{{record.sdate| date:'dd-MM-yyyy'}}</td>
                                    <td>{{record.edate| date:'dd-MM-yyyy'}}</td>
                                    <!-- <td>{{record.pdate| date:'dd-MM-yyyy'}}</td> -->
                                    <td>Dr. {{record.first_name}} {{record.last_name}}</td>
                                    <td>
                                      <a href="javascript:void(0);" class="fa fa-close"
                                        (click)="deletePrescription(record)" style="font-size:18px;color:red;"></a>
                                    </td>

                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <ng-template #no_data_templ>
                    <h5 class="mt-3 text-center mt-2"> NO RECORDS FOUND</h5>
                  </ng-template>
                </div>






              </div>
            </div>

            <div class="row pt-4">
              <div class="col-md-6">
                <div class="mt-2 mb-3">
                  <strong class="mr-3">Consultation Completed?
                    <span class="text-danger">*</span></strong>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input mb-0" type="radio" (click)="displayFollowup($event.target.value)"
                      name="completed" id="inlineRadio1" value="yes" formControlName="completed" />
                    <label class="form-check-label m-0" for="inlineRadio1">Yes</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input mb-0" type="radio" name="completed"
                      (click)="displayFollowup($event.target.value)" id="inlineRadio2" value="no"
                      formControlName="completed" />
                    <label class="form-check-label m-0" for="inlineRadio2">No</label>
                  </div>

                  <div *ngIf="
                      prescriptionForm.get('completed').hasError('required')
                    " class="invalid-feedback">
                    This is required
                  </div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="!displayFollowupSection">
                <input type="text" class="form-control mt-2" formControlName="remarks"
                  placeholder="If No, please explain" />
                <div *ngIf="prescriptionForm.get('remarks').hasError('required')" class="invalid-feedback">
                  This is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12" *ngIf="isEditable">
        <div class="card m-b-30">
          <div class="card-body" *ngIf="displayFollowupSection">
            <div>
              <h5 class="header-title text-primary">Follow Up Appointment</h5>
            </div>

            <div class="row pt-4">
              <div class="col-md-3">
                <strong class="mr-3">Follow Up Required</strong>
              </div>
              <div class="col-md-6">
                <div class="form-check form-check-inline pl-0 pl-md-2">
                  <input class="form-check-input mb-0" type="radio" formControlName="followupRequired"
                    name="followupRequired" id="inlineRadio1" checked="true" (click)="followupRequired($event)"
                    value="true" />
                  <label class="form-check-label m-0" for="inlineRadio1">Yes</label>
                </div>
                <div class="form-check form-check-inline pl-md-4 pl-0">
                  <input class="form-check-input mb-0" (click)="followupRequired($event)" type="radio"
                    formControlName="followupRequired" name="followupRequired" id="inlineRadio2" value="false" />
                  <label class="form-check-label m-0" for="inlineRadio2">No</label>
                </div>

                <!-- <div *ngIf="
                      prescriptionForm.get('followupRequired').hasError('required')
                    " class="invalid-feedback">
                  This is required
                </div> -->
              </div>
            </div>

            <div clas="row" *ngIf="isFollowupRequired">
              <div class="d-md-flex d-block mt-3">
                <div class="col-md-3 pl-0">
                  <strong class="mr-3">Follow Up Fee </strong>
                </div>
                <div class="col-md-4 pl-0">
                  <div class="form-check form-check-inline pl-md-3 pl-0">
                    <input class="form-check-input mb-0" type="radio" (change)="followupFee($event.target.value)"
                      id="inlineRadio1" name="feeCheck" checked="true" value="noFee" />
                    <label class="form-check-label m-0" for="inlineRadio1">No Fee</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input mb-0" type="radio" name="feeCheck" id="inlineRadio2"
                      (change)="followupFee($event.target.value)" value="defaultFee" />
                    <label class="form-check-label m-0" for="inlineRadio2">Rs.
                      {{
                      appointment?.physician_details?.physician_consultfee[0]
                      ?.followup_fee
                      }}</label>
                  </div>
                  <div class="form-check form-check-inline pl-md-3 pl-0">
                    <input class="form-check-input mb-0" type="radio" name="feeCheck" id="inlineRadio3" value="other"
                      (change)="followupFee($event.target.value)" />
                    <label class="form-check-label m-0" for="inlineRadio3">Other</label>
                  </div>
                </div>
                <div *ngIf="isAmountOther" class="col-md-5 pl-0">
                  <input type="number" min="0" formControlName="followupFeeOther" (keyup)="otherFee(parameter)"
                    class="form-control mt-2" />
                </div>
              </div>
            </div>
            <div class="row pt-2" *ngIf="isFollowupRequired">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-3">
                  <strong class="mr-3">Follow Up Fee Applied to Patient</strong>
                </div>
                <div class="col-md-9">
                  <label class="text-capitalize text-color pl-md-3 pl-0">Rs. {{ getControlLabel("followupFeePatient")
                    }}</label>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="isFollowupRequired">
              <div class="col-md-3">
                <strong>Last Date for follow up</strong>
              </div>
              <div class="col-md-3">
                <div class="d-flex pl-md-2 pl-0">
                  <!-- <mat-form-field class="border-top-0">
                    <input matInput [matDatepicker]="picker" formControlName="followupDate"
                      [formControl]="getControl('followupDate')" readonly required />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field> -->
                  <input class="form-control" formControlName="followupDate" name="followupDate" ngbDatepicker
                    #fdate="ngbDatepicker" data-date-inline-picker="true" id="followupDate" [minDate]="currentDate"
                    [markDisabled]="disableWeekends" />
                  <div>
                    <button class="btn btn-outline-secondary button-height calendar rounded-0" (click)="fdate.toggle()"
                      type="button" id="fDateButton">
                      <span class="fa fa-calendar"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isEditable" class="row float-right">
          <div class="col-sm-12">
            <button class="btn btn-primary pl-5 pr-5 mr-2 mb-2 mb-md-2 btn-rounded" type="button"
              [disabled]="prescriptionForm.invalid || !isEditable" (click)="sendPrescription()">
              Save
            </button>
            <button class="btn btn-secondary bg-color text-white pl-5 pr-5 mb-2 mb-md-2 btn-rounded" type="button"
              (click)="gotoPage()">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="prescriptions">
    <div class="bg-primary text-white p-1">
      <h5 class="mt-2 ml-4">
        PRESCRIPTION DETAILS
        <a style="cursor: pointer" href="{{ consultationReport?.p_url }}" *ngIf="consultationReport?.p_url"
          class="text-white" title="Download Prescription"><i class="fa fa-download float-right mr-2"
            aria-hidden="true"></i></a>
      </h5>
    </div>
    <div class="card m-b-30">
      <div class="card-body table-responsive">
        <div class="row">
          <div class="col-md-12">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Drug Name</th>
                  <th scope="col">Strength</th>
                  <th scope="col">Frequency</th>
                  <th scope="col">Medicine Intake</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                  <th scope="col">Additional Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let presc of prescriptions">
                  <td>{{ presc?.mname }}</td>
                  <td>{{ presc?.strength }}</td>
                  <td>{{ presc?.intakefreq }}</td>
                  <td>{{ presc?.intake }}</td>
                  <td>{{ presc?.sdate | date: dateFormat }}</td>
                  <td>{{ presc?.edate | date: dateFormat }}</td>
                  <td>{{ presc?.remarks }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--new changes -->
<ng-template #PDFModal>
  <div>
    <div class="modal-header">
      <!-- <i class="fa fa-close font-size-14"> Press Escape key to clsoe the preview</i> -->
      <button type="button" class="close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div>
      <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block"></pdf-viewer>
    </div>
  </div>
</ng-template>

<!-- CHAT UI -->
<label *ngIf="isEditable && onlineApt" class="text-color chat-label">LIVE CHAT -->
</label>
<input type="checkbox" id="check" />
<label *ngIf="isEditable" (click)="showChatModal = showChatModal ? false : true" class="chat-btn" for="check">
  <i class="fa fa-commenting-o comment"></i>
  <!-- <i class="fa fa-close close"></i> -->
</label>
<br />

<div class="wrapper" *ngIf="showChatModal" (click)="focus = true" [ngClass]="{ focusClass: focus === true }">
  <!--<div class="row">-->
  <!--<div class="mx-auto">-->
  <form [formGroup]="chatForm" #chatMsgForm>
    <div class="card border-primary border-2">
      <div class="card-header card-header-color d-flex text-white font-size-15 font-weight-600 justify-content-between">
        <div>CHAT BOX</div>
        <div *ngIf="room_id">Room Id: {{ room_id }}</div>
        <div>
          <a *ngIf="chatStarted" style="font-size: 25px; color: cyan" class="fa mr-3 cursor" [ngClass]="{
              'fa-phone': audioCall,
              'fa-video-camera': videoCall
            }" aria-hidden="true" (click)="
              notifyCall(videoCall ? 'video' : 'audio') && focus == false
            "></a>
          <b class="cursor" (click)="showChatModal = false">-</b>
        </div>
      </div>
      <div class="card-body chat-care" #chatScroll [scrollTop]="chatScroll.scrollHeight">
        <div *ngIf="!chatStarted; else elseSession" class="text-center">
          <label>------ No Messages ------</label>
        </div>
        <ng-template #elseSession>
          <div class="text-center">
            <label>------ Session started ------</label>
          </div>
        </ng-template>
        <ul class="chat" *ngFor="let msg of messages; let i = index">
          <li *ngIf="msg?.id == patient?.pid" class="patientChat clearfix">
            <span class="chat-img left clearfix mx-1">
              <i class="fa fa-user" style="font-size: 23px; color: orange" alt="Patient"></i>
            </span>
            <div class="chat-body-patient clearfix">
              <div class="header clearfix">
                <strong class="primary-font" style="color: orange">{{
                  patient?.first_name
                  }}</strong>
                &nbsp;&nbsp;
                <small class="right text-muted ml-3">
                  <span class="glyphicon glyphicon-time"></span>{{
                  msg.date | date: "dd-MMM-yyyy
                  (HH:mm)"
                  }}</small>
              </div>

              <img *ngIf="checkMsgType(msg?.body) === 'image'" style="width: 250px" src="{{ msg.body?.previewUrl }}"
                id="chatImage" (click)="previewImg(i)" alt="image" />

              <p *ngIf="checkMsgType(msg?.body) === 'string'">
                {{ msg?.body }}
              </p>

              <video *ngIf="checkMsgType(msg?.body) === 'video'" src="{{ msg.body?.previewUrl }}" id="chatVideo"
                style="width: 250px" alt="video" type="video/mp4" controls></video>

              <a *ngIf="checkMsgType(msg?.body) === 'application'" class="fa fa-file-pdf-o mr-2">
                <br />
                <a href="javascript:void(0);" aria-hidden="true" (click)="previewImg(i)"
                  style="color: blue; font-weight: normal">&nbsp;{{ msg.body?.name }}</a>
              </a>
            </div>
            <i *ngIf="
                checkMsgType(msg?.body) === 'video' ||
                checkMsgType(msg?.body) === 'image' ||
                checkMsgType(msg?.body) === 'application'
              " class="fa fa-download ml-2" aria-hidden="true" style="font-size: 15px; cursor: pointer"
              (click)="downloadDocument(msg.body)"></i>
          </li>
          <li *ngIf="msg?.id == physicianDetail?.u_id" class="physicianChat clearfix">
            <span class="chat-img right clearfix mx-1">
              <i class="fa fa-user-md" style="font-size: 23px; color: blue" alt="Physician"></i>
            </span>
            <div class="chat-body-physician clearfix">
              <div class="header clearfix">
                <small class="left text-muted">
                  <span class="glyphicon glyphicon-time"></span>
                  {{ msg.date | date: "dd-MMM-yyyy (HH:mm)" }}</small>&nbsp;&nbsp;
                <strong class="right primary-font mr-2" style="color: blue">{{
                  physicianDetail?.first_name
                  }}</strong>
              </div>

              <img *ngIf="checkMsgType(msg?.body) === 'image'" style="width: 250px" src="{{ msg.body?.previewUrl }}"
                id="chatImage" alt="image" />

              <p *ngIf="checkMsgType(msg?.body) === 'string'">
                {{ msg.body }}
              </p>

              <video *ngIf="checkMsgType(msg?.body) === 'video'" src="{{ msg.body?.previewUrl }}" id="chatVideo"
                style="width: 250px" alt="video" type="video/mp4" controls></video>

              <a *ngIf="checkMsgType(msg?.body) === 'application'" class="fa fa-file-pdf-o mr-2">
                <br />
                <a href="javascript:void(0);" aria-hidden="true" (click)="previewImg(i)"
                  style="color: blue; font-weight: normal">&nbsp;{{ msg.body?.name }}</a>
              </a>
            </div>
            <i *ngIf="
                checkMsgType(msg?.body) === 'video' ||
                checkMsgType(msg?.body) === 'image' ||
                checkMsgType(msg?.body) === 'application'
              " class="fa fa-download ml-2" aria-hidden="true" style="font-size: 15px; cursor: pointer"
              (click)="downloadDocument(msg.body)"></i>
          </li>
        </ul>
        <ul *ngIf="typingStatus?.status" class="typing-status">
          {{
          typingStatus?.status
          }}...
        </ul>
      </div>
      <div class="card-footer card-footer-color">
        <div *ngIf="!chatStarted" class="text-center">
          <button class="btn btn-primary" (click)="startChat()" [disabled]="!room_id">
            START CHAT
          </button>
        </div>

        <div *ngIf="chatStarted" class="input-group">
          <textarea id="btn-input" type="text" formControlName="chat_msg" class="form-control input-sm"
            placeholder="Type your message here..." rows="2" cols="3" style="line-height: 2; overflow: hidden"
            (keydown)="sendStatusTyping($event)" (keydown.enter)="sendMessage()"></textarea>
          <div class="image-upload">
            <label class="btn btn-outline-secondary calendar rounded-0" for="file-input"
              style="line-height: 2.5; background: white" id="attachFile">
              <span class="fa fa-paperclip fa-rotate-90" style="font-size: 32px; color: black"></span>
            </label>
            <input id="file-input" type="file" accept="application/pdf, image/*, docx/*"
              (change)="selectFile($event)" />
          </div>
          <span class="input-group-btn">
            <button class="btn btn-primary mt-2 ml-2" id="btn-chat" (click)="sendMessage()">
              <i class="fa fa-paper-plane"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
  </form>
  <!--</div>-->
  <!--</div>-->
</div>
<!-- video call -->
<div *ngIf="showOnlineJoinCall" [ngClass]="{
    minWindow: isMinimize === true,
    'video-screen': isMinimize === false
  }" (click)="focus = false" style="transform: translate3d(0px, 111px, 0px)" cdkDrag>
  <div>
    <div class="float-right">
      <span *ngIf="!isMinimize" class="mr-2 cursor" (click)="isMinimize = true"><b>_</b></span>
      <button *ngIf="!isMinimize" type="button" class="close mr-2" (click)="closeVideoScreen()">
        &times;
      </button>
      <img *ngIf="isMinimize" width="10px" class="mr-2 cursor" src="../../../assets/images/maximize.svg"
        (click)="isMinimize = false" />
    </div>
    <div>
      <!-- <i class="fa fa-close font-size-14"> Press Escape key to clsoe the preview</i> -->
      <h3 *ngIf="!isMinimize">Call</h3>
    </div>
    <div class="w-100">
      <app-home #home [isMinimize]="isMinimize" [aptid]="aptid" [role]="role"></app-home>
    </div>
  </div>
</div>
<!-- end video call -->
<!-- Join ChatRoom Notification -->
<ng-template #joinChatNotification let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title">Join Chat Notification</h2>
  </div>

  <!-- modal header -->

  <div *ngIf="notificationMessage" class="modal-body">
    {{ notificationMessage }}
    <!-- modal content -->
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary" (click)="closePopUp()">
      ok
    </button>
  </div>
</ng-template>

<!-- end -->